export function typeCheck(value: unknown) {
  if (Array.isArray(value)) {
    return "Array";
  } else if (typeof value === "string") {
    return "String";
  } else if (typeof value === "boolean") {
    return "Boolean";
  } else if (value !== null && typeof value === "object") {
    return "Object";
  } else {
    return "Other";
  }
}
